/**
 * <hubspot-form> — carga el embed v2 de HubSpot una sola vez por página y
 * renderiza el formulario sin estilos de HubSpot (css: ''), para que tome
 * los estilos de assets/hubspot-form.css.
 *
 * Atributos:
 *   data-portal       Portal ID de HubSpot
 *   data-form         Form ID
 *   data-region       Región (na1 por defecto)
 *   data-optin-label  (opcional) texto corto para el checkbox de consentimiento;
 *                     el texto legal completo queda colapsado tras "Ver más"
 *   data-optin-more / data-optin-less  textos del botón (Ver más / Ver menos)
 */
(function () {
  'use strict';

  var HS_SCRIPT_SRC = 'https://js.hsforms.net/forms/embed/v2.js';

  function loadHubspot() {
    if (window.hbspt && window.hbspt.forms && window.hbspt.forms.create) {
      return Promise.resolve();
    }
    if (!window.__hubspotFormLoader) {
      window.__hubspotFormLoader = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = HS_SCRIPT_SRC;
        script.charset = 'utf-8';
        script.async = true;
        script.addEventListener('load', function () { resolve(); });
        script.addEventListener('error', function () { reject(); });
        document.head.appendChild(script);
      });
    }
    return window.__hubspotFormLoader;
  }

  // Consentimiento: HubSpot pone la etiqueta y el texto legal en el mismo <span>,
  // separados por <br><br>. Deja solo la etiqueta corta en el <label> y mueve el
  // texto legal a un bloque colapsable fuera del <label> (tocar "Ver más" no marca
  // la casilla). El texto legal sigue en la página, solo oculto hasta expandirlo.
  var optinCount = 0;
  function enhanceOptin(host) {
    var label = host.dataset.optinLabel;
    if (!label) return;
    var more = host.dataset.optinMore || 'Ver más';
    var less = host.dataset.optinLess || 'Ver menos';

    host.querySelectorAll('.legal-consent-container .hs-form-booleancheckbox-display').forEach(function (display) {
      if (display.dataset.optinReady === 'true') return;
      var span = display.querySelector('span');
      if (!span) return;

      var html = span.innerHTML;
      var parts = html.split(/<br\s*\/?>\s*<br\s*\/?>/i);
      var legalHtml = parts.slice(1).join('<br><br>').trim();
      display.dataset.optinReady = 'true';

      span.textContent = label;
      span.classList.add('hsf-optin__label');
      if (!legalHtml) return;

      var id = 'hsf-optin-legal-' + (++optinCount);
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'hsf-optin__toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', id);
      toggle.textContent = more;

      var legal = document.createElement('div');
      legal.className = 'hsf-optin__legal';
      legal.id = id;
      legal.hidden = true;
      legal.innerHTML = legalHtml;

      toggle.addEventListener('click', function () {
        var open = legal.hidden;
        legal.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        toggle.textContent = open ? less : more;
      });

      display.insertAdjacentElement('afterend', legal);
      display.insertAdjacentElement('afterend', toggle);
    });
  }

  if (customElements.get('hubspot-form')) return;

  customElements.define('hubspot-form', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      var portalId = this.dataset.portal;
      var formId = this.dataset.form;
      var region = this.dataset.region || 'na1';
      var target = this.querySelector('.hsf__target');

      if (!portalId || !formId || !target) {
        console.warn('[hubspot-form] falta portal, form o contenedor');
        return;
      }
      this.dataset.ready = 'true';

      var host = this;
      loadHubspot()
        .then(function () {
          window.hbspt.forms.create({
            region: region,
            portalId: portalId,
            formId: formId,
            target: '#' + target.id,
            css: '',
            onFormReady: function () {
              enhanceOptin(host);
              host.classList.add('is-ready');
              console.log('[hubspot-form] listo', formId);
            },
            onFormSubmitted: function () {
              host.classList.add('is-submitted');
            }
          });
        })
        .catch(function () {
          host.classList.add('is-error');
          console.error('[hubspot-form] no se pudo cargar el script de HubSpot');
        });
    }
  });
})();
